import {
  createDataCollection as publicCreateDataCollection,
  getDataCollection as publicGetDataCollection,
  listDataCollections as publicListDataCollections,
  updateDataCollection as publicUpdateDataCollection,
  deleteDataCollection as publicDeleteDataCollection,
  restoreDataCollection as publicRestoreDataCollection,
  patchDataCollection as publicPatchDataCollection,
  createDataCollectionField as publicCreateDataCollectionField,
  updateDataCollectionField as publicUpdateDataCollectionField,
  deleteDataCollectionField as publicDeleteDataCollectionField,
  addDataCollectionPlugin as publicAddDataCollectionPlugin,
  deleteDataCollectionPlugin as publicDeleteDataCollectionPlugin,
  addPublishPlugin as publicAddPublishPlugin,
  deletePublishPlugin as publicDeletePublishPlugin,
  addUrlizedPlugin as publicAddUrlizedPlugin,
  deleteUrlizedPlugin as publicDeleteUrlizedPlugin,
  addMultilingualPlugin as publicAddMultilingualPlugin,
  deleteMultilingualPlugin as publicDeleteMultilingualPlugin,
  addCmsPlugin as publicAddCmsPlugin,
  deleteCmsPlugin as publicDeleteCmsPlugin,
  addCatalogPlugin as publicAddCatalogPlugin,
  deleteCatalogPlugin as publicDeleteCatalogPlugin,
  addDraftItemsPlugin as publicAddDraftItemsPlugin,
  deleteDraftItemsPlugin as publicDeleteDraftItemsPlugin,
  patchDataCollectionField as publicPatchDataCollectionField,
} from './data-v2-data-collection-collections.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicCreateDataCollection> &
    typeof publicCreateDataCollection
> = /*#__PURE__*/ createRESTModule(publicCreateDataCollection);
export const getDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicGetDataCollection> &
    typeof publicGetDataCollection
> = /*#__PURE__*/ createRESTModule(publicGetDataCollection);
export const listDataCollections: MaybeContext<
  BuildRESTFunction<typeof publicListDataCollections> &
    typeof publicListDataCollections
> = /*#__PURE__*/ createRESTModule(publicListDataCollections);
export const updateDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDataCollection> &
    typeof publicUpdateDataCollection
> = /*#__PURE__*/ createRESTModule(publicUpdateDataCollection);
export const deleteDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDataCollection> &
    typeof publicDeleteDataCollection
> = /*#__PURE__*/ createRESTModule(publicDeleteDataCollection);
/** @internal */
export const restoreDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicRestoreDataCollection> &
    typeof publicRestoreDataCollection
> = /*#__PURE__*/ createRESTModule(publicRestoreDataCollection);
export const patchDataCollection: MaybeContext<
  BuildRESTFunction<typeof publicPatchDataCollection> &
    typeof publicPatchDataCollection
> = /*#__PURE__*/ createRESTModule(publicPatchDataCollection);
export const createDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicCreateDataCollectionField> &
    typeof publicCreateDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicCreateDataCollectionField);
export const updateDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDataCollectionField> &
    typeof publicUpdateDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicUpdateDataCollectionField);
export const deleteDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDataCollectionField> &
    typeof publicDeleteDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicDeleteDataCollectionField);
export const addDataCollectionPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddDataCollectionPlugin> &
    typeof publicAddDataCollectionPlugin
> = /*#__PURE__*/ createRESTModule(publicAddDataCollectionPlugin);
export const deleteDataCollectionPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDataCollectionPlugin> &
    typeof publicDeleteDataCollectionPlugin
> = /*#__PURE__*/ createRESTModule(publicDeleteDataCollectionPlugin);
/** @internal */
export const addPublishPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddPublishPlugin> &
    typeof publicAddPublishPlugin
> = /*#__PURE__*/ createRESTModule(publicAddPublishPlugin);
/** @internal */
export const deletePublishPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeletePublishPlugin> &
    typeof publicDeletePublishPlugin
> = /*#__PURE__*/ createRESTModule(publicDeletePublishPlugin);
/** @internal */
export const addUrlizedPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddUrlizedPlugin> &
    typeof publicAddUrlizedPlugin
> = /*#__PURE__*/ createRESTModule(publicAddUrlizedPlugin);
/** @internal */
export const deleteUrlizedPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeleteUrlizedPlugin> &
    typeof publicDeleteUrlizedPlugin
> = /*#__PURE__*/ createRESTModule(publicDeleteUrlizedPlugin);
/** @internal */
export const addMultilingualPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddMultilingualPlugin> &
    typeof publicAddMultilingualPlugin
> = /*#__PURE__*/ createRESTModule(publicAddMultilingualPlugin);
/** @internal */
export const deleteMultilingualPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeleteMultilingualPlugin> &
    typeof publicDeleteMultilingualPlugin
> = /*#__PURE__*/ createRESTModule(publicDeleteMultilingualPlugin);
/** @internal */
export const addCmsPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddCmsPlugin> & typeof publicAddCmsPlugin
> = /*#__PURE__*/ createRESTModule(publicAddCmsPlugin);
/** @internal */
export const deleteCmsPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCmsPlugin> & typeof publicDeleteCmsPlugin
> = /*#__PURE__*/ createRESTModule(publicDeleteCmsPlugin);
/** @internal */
export const addCatalogPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddCatalogPlugin> &
    typeof publicAddCatalogPlugin
> = /*#__PURE__*/ createRESTModule(publicAddCatalogPlugin);
/** @internal */
export const deleteCatalogPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCatalogPlugin> &
    typeof publicDeleteCatalogPlugin
> = /*#__PURE__*/ createRESTModule(publicDeleteCatalogPlugin);
/** @internal */
export const addDraftItemsPlugin: MaybeContext<
  BuildRESTFunction<typeof publicAddDraftItemsPlugin> &
    typeof publicAddDraftItemsPlugin
> = /*#__PURE__*/ createRESTModule(publicAddDraftItemsPlugin);
/** @internal */
export const deleteDraftItemsPlugin: MaybeContext<
  BuildRESTFunction<typeof publicDeleteDraftItemsPlugin> &
    typeof publicDeleteDraftItemsPlugin
> = /*#__PURE__*/ createRESTModule(publicDeleteDraftItemsPlugin);
export const patchDataCollectionField: MaybeContext<
  BuildRESTFunction<typeof publicPatchDataCollectionField> &
    typeof publicPatchDataCollectionField
> = /*#__PURE__*/ createRESTModule(publicPatchDataCollectionField);

export {
  CollectionType,
  Direction,
  DataOperation,
  CollectionOperation,
  Type,
  QueryOperator,
  PageLinkType,
  FieldPluginType,
  Permission,
  Role,
  Status,
  LifecycleStatus,
  Format,
  AccessLevel,
  PluginType,
  PagingMode,
  Segment,
  SortOrder,
  DraftItemsPluginConflictAction,
  PublishPluginConflictAction,
  DraftItemsRemovalAction,
  TenantMode,
  Order,
  IndexStatus,
  IndexSource,
  WebhookIdentityType,
} from './data-v2-data-collection-collections.universal.js';
export {
  DataCollection,
  Sort,
  CollectionCapabilities,
  IndexLimits,
  IndexQuotaLimits,
  Field,
  FieldRangeValidationsOneOf,
  TextValidation,
  EnumValues,
  TypeMetadata,
  TypeMetadataMetadataOneOf,
  FieldCapabilities,
  ObjectField,
  FieldsPattern,
  UrlizedOnlyPattern,
  Calculator,
  CalculatorPatternOneOf,
  Reference,
  MultiReference,
  _Object,
  _Array,
  PageLink,
  Slug,
  Text,
  TextValidationOneOf,
  _Number,
  _Date,
  _DateDefaultValueOneOf,
  _DateMinDateOneOf,
  _DateMaxDateOneOf,
  Datetime,
  DatetimeDefaultValueOneOf,
  DatetimeMinDateOneOf,
  DatetimeMaxDateOneOf,
  Image,
  _Boolean,
  Document,
  Url,
  RichText,
  Video,
  ArrayString,
  ArrayDocument,
  Audio,
  Time,
  RichContent,
  MediaGallery,
  Address,
  Email,
  LegacyColor,
  NumberRange,
  StringLengthRange,
  ArraySizeRange,
  FieldPlugin,
  FieldPluginOptionsOneOf,
  CmsOptions,
  CategoryFieldOptions,
  FieldCondition,
  Permissions,
  Plugin,
  PluginOptionsOneOf,
  SiteSort,
  DraftPermissions,
  AllowedDraftPermissions,
  PublishPluginOptions,
  SingleItemPluginOptions,
  UrlizedPluginOptions,
  MultilingualOptions,
  PageLinkPluginOptions,
  PluginCmsOptions,
  CatalogOptions,
  DraftItemsPluginOptions,
  DraftItemsPluginOptionsPairedCollectionOneOf,
  DataPermissions,
  AllowedDataPermissions,
  DataCollectionClonedEvent,
  DataCollectionChangedEvent,
  FieldUpdate,
  PluginUpdate,
  PermissionsUpdate,
  StrictModeUpdate,
  DataCollectionEvictedEvent,
  CreateDataCollectionRequest,
  CreateDataCollectionResponse,
  GetDataCollectionRequest,
  GetDataCollectionResponse,
  ListDataCollectionsRequest,
  Sorting,
  Paging,
  ListDataCollectionsResponse,
  PagingMetadataV2,
  BulkGetDataCollectionsRequest,
  BulkGetDataCollectionsResponse,
  ApplicationError,
  FailedCollection,
  UpdateDataCollectionRequest,
  UpdateDataCollectionResponse,
  DeleteDataCollectionRequest,
  DeleteDataCollectionResponse,
  RestoreDataCollectionRequest,
  RestoreDataCollectionResponse,
  PatchDataCollectionRequest,
  PatchDataCollectionResponse,
  CreateDataCollectionFieldRequest,
  CreateDataCollectionFieldResponse,
  UpdateDataCollectionFieldRequest,
  UpdateDataCollectionFieldResponse,
  DeleteDataCollectionFieldRequest,
  DeleteDataCollectionFieldResponse,
  AddDataCollectionPluginRequest,
  AddDataCollectionPluginResponse,
  DeleteDataCollectionPluginRequest,
  DeleteDataCollectionPluginResponse,
  AddPublishPluginRequest,
  AddPublishPluginResponse,
  DeletePublishPluginRequest,
  DeletePublishPluginResponse,
  AddUrlizedPluginRequest,
  AddUrlizedPluginResponse,
  DeleteUrlizedPluginRequest,
  DeleteUrlizedPluginResponse,
  AddMultilingualPluginRequest,
  AddMultilingualPluginResponse,
  DeleteMultilingualPluginRequest,
  DeleteMultilingualPluginResponse,
  AddCmsPluginRequest,
  AddCmsPluginResponse,
  DeleteCmsPluginRequest,
  DeleteCmsPluginResponse,
  AddCatalogPluginRequest,
  AddCatalogPluginResponse,
  DeleteCatalogPluginRequest,
  DeleteCatalogPluginResponse,
  AddDraftItemsPluginRequest,
  AddDraftItemsPluginResponse,
  DeleteDraftItemsPluginRequest,
  DeleteDraftItemsPluginResponse,
  PatchDataCollectionFieldRequest,
  PatchDataCollectionFieldResponse,
  UpdateDataPermissionsRequest,
  UpdateDataPermissionsResponse,
  BulkGetDataCollectionsPageBySnapshotsRequest,
  BulkGetDataCollectionsPageBySnapshotsRequestTenantModeOptionsOneOf,
  AppOptions,
  BulkGetDataCollectionsPageBySnapshotsResponse,
  SnapshotCollection,
  Index,
  IndexField,
  Failure,
  CreateDataCollectionsSnapshotRequest,
  CreateDataCollectionsSnapshotResponse,
  CreateAppCollectionsSnapshotRequest,
  CollectionDefinition,
  CreateAppCollectionsSnapshotResponse,
  RestoreDataCollectionsFromSnapshotRequest,
  Destination,
  RestorationCollection,
  RestoreDataCollectionsFromSnapshotResponse,
  DeleteDataCollectionsSnapshotRequest,
  DeleteDataCollectionsSnapshotResponse,
  CreateMigratedCollectionsSnapshotRequest,
  CreateMigratedCollectionsSnapshotResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetDataCollectionOptions,
  ListDataCollectionsOptions,
  PatchDataCollection,
  CreateDataCollectionFieldOptions,
  UpdateDataCollectionFieldOptions,
  DeleteDataCollectionFieldOptions,
  AddDataCollectionPluginOptions,
  DeleteDataCollectionPluginOptions,
  AddPublishPluginOptions,
  AddUrlizedPluginOptions,
  AddMultilingualPluginOptions,
  AddCmsPluginOptions,
  AddCatalogPluginOptions,
  AddDraftItemsPluginOptions,
  DeleteDraftItemsPluginOptions,
} from './data-v2-data-collection-collections.universal.js';
export {
  CollectionTypeWithLiterals,
  DirectionWithLiterals,
  DataOperationWithLiterals,
  CollectionOperationWithLiterals,
  TypeWithLiterals,
  QueryOperatorWithLiterals,
  PageLinkTypeWithLiterals,
  FieldPluginTypeWithLiterals,
  PermissionWithLiterals,
  RoleWithLiterals,
  StatusWithLiterals,
  LifecycleStatusWithLiterals,
  FormatWithLiterals,
  AccessLevelWithLiterals,
  PluginTypeWithLiterals,
  PagingModeWithLiterals,
  SegmentWithLiterals,
  SortOrderWithLiterals,
  DraftItemsPluginConflictActionWithLiterals,
  PublishPluginConflictActionWithLiterals,
  DraftItemsRemovalActionWithLiterals,
  TenantModeWithLiterals,
  OrderWithLiterals,
  IndexStatusWithLiterals,
  IndexSourceWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './data-v2-data-collection-collections.universal.js';
